import React from 'react';
import '../style.scss';
import { EstablishError } from 'views/components/atoms/establishes/error';
import { EstablishHeader } from 'views/components/atoms/establishes/header';
import { EstablishRadio } from 'views/components/atoms/establishes/radio';

export type InputAdvisabilityProps = {
  title: string;
  name: string;
  agreeText: string;
  denialText: string;
  agreeValue: string;
  denialValue: string;
  checked: boolean | undefined;
  onChange: (value: boolean) => void;
  isEnabled: boolean;
  errorText?: string;
  batchDangerWord?: string;
  reverse?: boolean;
  description?: string;
  disabled?: boolean;
};

export const InputAdvisability = (props: InputAdvisabilityProps) => {
  const {
    title,
    name,
    agreeText,
    denialText,
    checked,
    onChange,
    agreeValue,
    denialValue,
    isEnabled,
    errorText,
    batchDangerWord,
    reverse = false,
    description = '',
    disabled = false,
  } = props;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value === 'true';
    onChange(newValue);
  };

  const displayList = [
    <EstablishRadio
      key={'agree'}
      name={name}
      text={agreeText}
      value={agreeValue}
      checked={checked === true}
      onChange={handleChange}
      disabled={disabled}
    />,
    <EstablishRadio
      key={'denial'}
      name={name}
      text={denialText}
      value={denialValue}
      checked={checked === false}
      onChange={handleChange}
      disabled={disabled}
    />,
  ];
  return (
    <div className="inputWrapper">
      <EstablishHeader headerTitle={title} batchDangerWord={batchDangerWord} />
      {description && <span className="establishWrapper_description">{description}</span>}
      <fieldset className={name}>{reverse ? displayList.reverse() : displayList}</fieldset>
      <EstablishError isEnabled={isEnabled} errorText={errorText} />
    </div>
  );
};
